import {ErrorMessage, Field, Form, Formik} from 'formik'
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {SubDomin} from '../../../../Utils/FormikComponents/SubDomin'
import {whiteLabelUserSchema} from '../../../../Utils/_helpers/ValidationSchema'

import {ColorPicker, useColor} from 'react-color-palette'
import 'react-color-palette/lib/css/styles.css'
import {
  CreateWhiteLabel as CreateWhiteLabelUser,
  UpdateWhiteLabel,
} from '../WhiteLabelSlice/WhiteLabelSlice'

const CreateWhiteLabelPopup = ({show, handleClose, data}: any) => {
  const [color, setColor] = useColor('hex', '#121212')
  const param: any = useLocation()
  const dispatch = useDispatch()

  interface whiteLabelInterface {
    name: String
    logo: String
    email: String
    companyName: String
    mobile: Number | String
    whiteLabelSubdomain: String
    password: String
    editting: boolean
  }

  const [whitelabelData, setWhitelabelData] = useState<whiteLabelInterface>({
    name: '',
    logo: '',
    email: '',
    companyName: '',
    mobile: '',
    whiteLabelSubdomain: '',
    password: '',
    editting: false,
  })
  useEffect(() => {
    if (data) {
      setWhitelabelData({
        ...whitelabelData,
        ...{
          name: data?.user?.name,
          logo: data?.whiteLabelLogo,
          email: data?.user?.email,
          companyName: data?.user?.companyName,
          mobile: data?.user?.mobile,
          whiteLabelSubdomain: data?.whiteLabelSubdomain,
          editting: true,
        },
      })
    }
  }, [data])
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
        scrollabel={'true'}
      >
        <div className='modal-header'>
          <h2>{`${
            param?.pathname.split('/')?.[1] !== 'whiteLabel-profile' ? 'Create' : 'Update'
          } White Label `}</h2>
          <div className='btn btn-icon  bi bi-x fs-5' onClick={handleClose}></div>
        </div>
        <div className='modal-body px-20 py-5 admin_list_modals'>
          <Formik
            initialValues={whitelabelData}
            validationSchema={whiteLabelUserSchema}
            onSubmit={(val: any) => {
              const values = {
                ...val,
                name: val?.name?.trim(),
                companyName: val?.companyName?.trim(),
              }
              const finalData = new FormData()
              for (var key in values) {
                finalData.append(key, values[key])
              }
              if (data) {
                dispatch(UpdateWhiteLabel({id: data?._id, data: finalData}))
                handleClose()
              } else {
                dispatch(CreateWhiteLabelUser(finalData))
                handleClose()
              }
            }}
          >
            {({values, setFieldValue}: any) => (
              <Form>
                <div className='row mb-6'>
                  <label className='col-form-label required fw-bold fs-6'>Logo</label>
                  <div
                    className='image-input image-input-outline w-auto'
                    data-kt-image-input='true'
                  >
                    {typeof values.logo !== 'object' ? (
                      <img
                        src={
                          values.logo === ''
                            ? toAbsoluteUrl('/media/avatars/blank.png')
                            : values.logo
                        }
                        alt='poster'
                        width={125}
                        height={125}
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(values.logo)}
                        alt='poster'
                        width={125}
                        height={125}
                      />
                    )}

                    <label
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Change avatar'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-pencil-fill'
                        viewBox='0 0 16 16'
                      >
                        <path d='M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z' />
                      </svg>
                      <input
                        type='file'
                        name='logo'
                        onChange={(event: any) => setFieldValue('logo', event?.target.files[0])}
                        accept='.png, .jpg, .jpeg'
                      />
                    </label>

                    <span
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='remove'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Remove avatar'
                      onClick={(event: any) => setFieldValue('logo', '')}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='25'
                        height='25'
                        fill='currentColor'
                        className='bi bi-x'
                        viewBox='0 0 16 16'
                      >
                        <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                      </svg>
                    </span>
                  </div>
                  {/* </div> */}
                </div>

                <ErrorMessage name='logo'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>
                <div className='row'>
                  <div className='col-12'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='fullName'>
                      Full Name
                    </label>
                    <Field
                      id={'fullName'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='name'
                      type='text'
                    />
                    <ErrorMessage name='name'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='companyName'>
                      Company Name
                    </label>
                    <Field
                      id={'companyName'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='companyName'
                      type='text'
                    />
                    <ErrorMessage name='companyName'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='email'>
                      Email
                    </label>
                    <Field
                      id={'email'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='email'
                      type='text'
                    />
                    <ErrorMessage name='email'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='mobile'>
                      Phone
                    </label>
                    <Field
                      id={'mobile'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='mobile'
                      type='text'
                    />
                    <ErrorMessage name='mobile'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                {!data && (
                  <div className='row'>
                    <div className='col-12'>
                      <label className='col-form-label required fw-bold fs-6' htmlFor='password'>
                        Password
                      </label>
                      <Field
                        id={'password'}
                        className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                        name='password'
                        type='text'
                      />
                      <ErrorMessage name='password'>
                        {(msg: string) => <span className='text-danger'>{msg}</span>}
                      </ErrorMessage>
                    </div>
                  </div>
                )}
                <div className='row'>
                  <label
                    className='col-form-label required fw-bold fs-6'
                    htmlFor='whiteLabelSubdomain'
                  >
                    SUB DOMAIN
                  </label>
                  <Field
                    id={'whiteLabelSubdomain'}
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    name='whiteLabelSubdomain'
                    type='text'
                    disabled={data !== undefined}
                    component={SubDomin}
                  />
                  <ErrorMessage name='whiteLabelSubdomain'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div>
                {/* <div className='row'>
                  <label
                    className='col-form-label required fw-bold fs-6'
                    htmlFor='whiteLabelSubdomain'
                  ></label>
                  <ColorPicker
                    width={456}
                    height={228}
                    color={color}
                    onChange={(e: any) => {}}
                    hideHSV
                    dark
                  />
                  ;
                  <ErrorMessage name='whiteLabelSubdomain'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div> */}

                <div className='modal-footer d-flex justify-content-center'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      className='btn btn-md gray_bg_purple'
                      type='button'
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                  </div>

                  <button type='submit' className='btn btn-primary ml-2'>
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default CreateWhiteLabelPopup
